// Package imports:
import React from 'react';
// Component imports:
import Entrypoint from '../Entrypoint';
import CompanySubPage from '../../components/Company/CompanySubPage/CompanySubPage';
import ViewConstructionsReportComp from '../../components/Company/ViewConstructionsReport/ViewConstructionsReport';
// Type imports:
import { IAuthenticationWithIdAndEventId } from '../../types/CompanyTypes';

const ViewConstructionsReport: React.FC<IAuthenticationWithIdAndEventId> = ({
    id,
    eventId,
    isAuthenticated,
    isSubscriber
}) => {
    return (
        <Entrypoint>
            <CompanySubPage 
                id={id} 
                title='Vinnuvélar'
                isAuthenticated={isAuthenticated}
                isSubscriber={isSubscriber}
                subTitle='Vinnuvélar - Skýrsla'
                noAd
                component={
                    <ViewConstructionsReportComp
                        id={id ?? ''}
                        eventId={eventId ?? ''}
                    />
                } 
            />
        </Entrypoint>
    );
}

export default ViewConstructionsReport;